import React from "react"
import styled from "@emotion/styled"
import * as httpx from "httpx"
import * as typography from "typography"
import * as layouts from "layouts"
import * as api from "./api"

interface props extends layouts.containers.FlexProps {
	accounts: api.AvailableResponse
	onChange(c: Promise<api.Authn>): void
}

const AccountItem = styled(layouts.containers.box)`
	border-left: 5px solid transparent;
	padding-left: 16px;
	font-size: 20px;
	font-weight: 500;
	line-height: 36px;
	letter-spacing: -0.02em;
	text-overflow: ellipsis;
	overflow-x: hidden;
	white-space: nowrap;
	min-height: 36px;
	max-width: 100%;
	margin: 5px 0px 10px 0px;
	&:hover {
		border-left: 5px solid ${layouts.theme.colors.blue.blue};
		border-radius: unset;
	}
`

export default function Available(props: React.PropsWithChildren<props>): JSX.Element {
	const { accounts, onChange, ...rest } = props
	if (accounts.items.length === 0) return <></>

	return (
		<>
			<typography.h3 mx="auto" my="10px" fontSize="22px" color={layouts.theme.colors.grey.medium}>
				Or choose from accounts you have been invited to:
			</typography.h3>
			<layouts.containers.flex className="available" flexDirection="column" overflow="auto" {...rest}>
				{accounts.items.map((a) => (
					<AccountItem
						key={a.account?.id}
						onClick={() => {
							onChange(api.accounts.available.accept(httpx.options.bearer(a.token)).then((joined) => joined.login!))
						}}
						title={`${a.account?.description} - ${a.account?.id.slice(0, 4)}`}
					>
						{a.account?.description} - {a.account?.id.slice(0, 4)}
					</AccountItem>
				))}
			</layouts.containers.flex>
		</>
	)
}
